/**
 * `{name}` placeholder substitution — the one implementation, shared by `t()`
 * (I18nProvider) and the components that take pre-translated label templates
 * as props (offers editor, uploaders). Replaces every occurrence; unknown
 * placeholders are left as-is.
 */
export function interpolate(template: string, vars?: Record<string, string | number>): string {
  if (!vars) return template;
  return Object.entries(vars).reduce((out, [k, v]) => out.split(`{${k}}`).join(String(v)), template);
}
